import { render, staticRenderFns } from "./NavigationCard.vue?vue&type=template&id=12f15d43&scoped=true"
import script from "./NavigationCard.vue?vue&type=script&lang=js"
export * from "./NavigationCard.vue?vue&type=script&lang=js"
import style0 from "./NavigationCard.vue?vue&type=style&index=0&id=12f15d43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f15d43",
  null
  
)

export default component.exports